import { either } from "fp-ts"
import { pipe } from "fp-ts/function"
import * as D from "io-ts/Decoder"

/**
 * Same as `D.partial`, but in case of failure it returns empty object.
 */
export const laxPartial = <A>(properties: {
  [K in keyof A]: D.Decoder<unknown, A[K]>
}): D.Decoder<unknown, Partial<{ [K_1 in keyof A]: A[K_1] }>> => ({
  decode: (input) =>
    pipe(D.partial(properties).decode(input), (result) =>
      either.isLeft(result) ? either.right({}) : result
    ),
})
